(() => {
  if (customElements.get('cart-recommendations-carousel')) return;

  customElements.define('cart-recommendations-carousel', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.gallery = Object.create(window.MarmeladeCarousel);
      Object.assign(this.gallery, {
        _carouselTrack: this.querySelector('[data-carousel-track]'),
        _carouselDots: this.querySelector('[data-carousel-dots]'),
        _carouselIndex: 0,
        _desktopMediaQuery: { matches: false },
        updateCarouselVideoPlayback() {},
      });
      this.gallery.bindCarouselSwipe();
      this.addEventListener('dragstart', event => event.preventDefault(), options);
      this.addEventListener('pointerdown', () => { this.gallery._carouselSuppressClick = false; }, { ...options, capture: true });
      this.addEventListener('click', event => {
        if (this.gallery._carouselSuppressClick && event.detail !== 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const arrow = event.target.closest('[data-carousel-step]');
        if (arrow) {
          const direction = Number(arrow.dataset.carouselStep);
          this.gallery.showCarouselImage(this.gallery._carouselIndex + direction, direction);
          return;
        }
        const dot = event.target.closest('[data-carousel-dot]');
        if (dot) this.gallery.showCarouselImage(Number(dot.dataset.carouselDot));
      }, { ...options, capture: true });
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        event.stopPropagation();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        this.gallery.showCarouselImage(this.gallery._carouselIndex + direction, direction);
      }, options);
      this.refresh();
    }

    refresh() {
      if (!this.gallery) return;
      const gallery = this.gallery;
      gallery._carouselTransitionToken = (gallery._carouselTransitionToken || 0) + 1;
      gallery._cancelCarouselSwipe();
      window.clearTimeout(gallery._carouselAnimationTimer);
      gallery._carouselAnimating = false;
      const cards = Array.from(gallery._carouselTrack.querySelectorAll('[data-carousel-image]'));
      const index = Math.max(0, Math.min(gallery._carouselIndex, cards.length - 1));
      gallery._carouselDots.replaceChildren();
      gallery._carouselDots.hidden = cards.length < 2;
      this.querySelector('[data-carousel-navigation]').hidden = cards.length < 2;
      cards.forEach((card, position) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.dataset.carouselDot = String(position);
        const title = card.querySelector('.cart-overlay__item-copy > a').textContent;
        dot.setAttribute('aria-label', this.dataset.showLabel.replace('__TITLE__', title));
        gallery._carouselDots.append(dot);
      });
      gallery.showCarouselImage(index, 0);
    }

    disconnectedCallback() {
      this.gallery?._cancelCarouselSwipe();
      this.gallery?._carouselSwipeEvents?.abort();
      window.clearTimeout(this.gallery?._carouselAnimationTimer);
      if (this.gallery) this.gallery._carouselTransitionToken++;
      this.events?.abort();
    }
  });
})();
